// extracted by mini-css-extract-plugin
module.exports = {"titleWidth":"25%","brandWidth":"8%","budgetWidth":"8%","budgetRemainingWidth":"8%","dateStartWidth":"8%","dateEndWidth":"8%","scopesWidth":"15%","statusWidth":"unset"};